<script lang="ts" setup>
import { computed, onMounted, PropType, ref, watch } from 'vue';
import { QueueRelationModel } from '@/components/task-forms/models';
import { default as QueuesListItem } from './queues-list-item.vue';
import { TirPmScrollbar } from 'tir-components';

/**Параметры */
const props = defineProps({
  /**id проекта */
  projectId: { type: Number, required: true },
  /**Список очередей задачи */
  queues: { type: Array as PropType<QueueRelationModel[]> },
  editing: { type: Boolean, default: true },
  /**id выбранной очереди */
  selectedQueueId: { type: String },
  /**ссылка на компонент скролбара */
  scrollbar: { type: Object as PropType<InstanceType<typeof TirPmScrollbar>> },
});
/**События */
const emit = defineEmits<{
  /**Удаление задачи из очереди */
  remove: [queueId: string];
}>();

/**Ссылка на подзадачи */
const $queuesList = ref<InstanceType<typeof QueuesListItem>>();

/**Выбраный элемент очереди */
const selectElementQueue = computed(() => {
  return props.queues.findIndex((queue) => queue.Id === props.selectedQueueId);
});

/**Очередь */
const queueElement = computed(() => {
  return $queuesList.value[selectElementQueue.value]?.queueItem;
});

/**Спуститься до задачи */
const scrollToLastElement = () => {
  const scrollContainer = props.scrollbar.$scroll;

  const currentScrollTop = scrollContainer.scrollTop;
  const targetScrollTop =
    currentScrollTop +
    queueElement.value.getBoundingClientRect().top -
    scrollContainer.getBoundingClientRect().top -
    20;

  scrollContainer.scrollTo({
    top: targetScrollTop,
    behavior: 'smooth',
  });
};

defineExpose({
  queuesList: $queuesList,
});

watch(
  () => props.queues,
  () => {
    if (selectElementQueue.value > -1) scrollToLastElement();
  },
);
</script>
<template>
  <div class="queues-list">
    <QueuesListItem
      ref="$queuesList"
      v-for="(queue, idx) in queues"
      :projectId="projectId"
      :queue="queue"
      :key="idx"
      @remove="emit('remove', $event)"
      :editing="editing"
    />
  </div>
</template>
<style lang="scss" scoped>
.queues-list {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
</style>
